import { staticMaxSteps as maxStepsC } from '@hooks/useSteps';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import storage from './encryptedStorage';

type CompletedStepT = Record<number, boolean>;
type FlowT = {
  maxSteps: number;
  completedSteps: CompletedStepT;
  hasFamilyMembers: boolean;
};

const buildCompletedSteps = (maxSteps: number): CompletedStepT => {
  const completedSteps: CompletedStepT = {};
  for (let i = 1; i <= maxSteps; i++) {
    completedSteps[i] = false;
  }
  return completedSteps;
};

const flowBase = {
  maxSteps: maxStepsC,
  completedSteps: buildCompletedSteps(maxStepsC),
  hasFamilyMembers: false,
};

interface FlowStoreStateI {
  flow: FlowT;
  isInitialized: boolean;
  setInitialized: () => void;
  setCompletedStep: (completedStep: CompletedStepT) => void;
  setHasFamilyMembers: (value: boolean) => void;
  resetFlow: () => void;
}

const useFlowStore = create<FlowStoreStateI>()(
  persist(
    (set) => ({
      flow: flowBase,
      isInitialized: false,
      setInitialized: () => set({ isInitialized: true }),
      setCompletedStep: (completedSteps: CompletedStepT) =>
        set((state) => {
          const updatedCompletedSteps: CompletedStepT = {
            ...state.flow.completedSteps,
            ...completedSteps,
          };
          return {
            flow: { ...state.flow, completedSteps: updatedCompletedSteps },
          };
        }),
      setHasFamilyMembers: (value: boolean) =>
        set((state) => ({
          flow: { ...state.flow, hasFamilyMembers: value },
        })),
      resetFlow: () => set({ flow: flowBase }),
    }),
    {
      name: 'deceso-flow-storage',
      storage,
    }
  )
);

export default useFlowStore;
